import jsPDF from 'jspdf'
import ReactDOMServer from 'react-dom/server'
import logo from "../Assets/Images/brillJustjpg.png"
import call from "../Assets/Images/phone.png"
import tow from "../Assets/Images/towing.png"
import mail from "../Assets/Images/supportMail.png"
import allianceLogo from "../Assets/Images/AllianceLogo.png"
import onlineSupport from "../Assets/Images/onlineSupport.png"
import towAssist from "../Assets/Images/towAssist.png"
import rundown from "../Assets/Images/rundown.png"
import tyre from "../Assets/Images/tyre.png"
import fuel from "../Assets/Images/fuelAssist.png"
import customer from "../Assets/Images/customer.png"
import urgent from "../Assets/Images/urgent.png"
import emergency from "../Assets/Images/emergencyAssit.png"
import keyAssist from "../Assets/Images/keyAssit.png"
import taxiAssist from "../Assets/Images/taxiAssit.png"
import accomadation from "../Assets/Images/accomadationAssit.png"
import outward from "../Assets/Images/outWard.png"
import arrangement from "../Assets/Images/arrangement.png"
import coverage from "../Assets/Images/coverageAssit.png"
import ambulance from "../Assets/Images/Ambulance_Icon.png"
import future from "../Assets/Images/futureLogo.png"
import iciciLombard from "../Assets/Images/iciciLombard.png"
import manipalcignaLogo from "../Assets/Images/Manipal.png"
import '../Components/PDF-Container/Pdf.css'
import PoppinsRegular from "../Assets/Font/Merriweather,Poppins/Poppins/Poppins-Regular.ttf"
import moment from 'moment'
import highligtedCircle from "../Assets/Images/initiate claim.png"
import tick from "../Assets/Images/tick.png"


// ─── Helpers ────────────────────────────────────────────────────────────────

const calcAmounts = (formData) => {
  const basicPlanAmt = parseInt(formData.planBuyPrice) / 1.18
  const basicCcAmt = formData.cc_plan_amount
    ? parseInt(formData.cc_plan_amount) / 1.18
    : ""
  const planGST =
    parseInt(formData.planBuyPrice) +
    (formData.cc_plan_amount ? parseInt(formData.cc_plan_amount) : 0) -
    basicPlanAmt -
    basicCcAmt
  return {
    basicPlanAmt: basicPlanAmt.toFixed(2),
    basicCcAmt: formData.cc_plan_amount && parseInt(parseInt(formData.cc_plan_amount) / 1.18),
    planGST: planGST.toFixed(2),
  }
}

const calcDates = (formData) => {
  const tenure = formData.tenure
  let tenurePa = formData.tenurePa
  const startDate = moment(formData.policyStartDate)
  const tenureEnd = moment(startDate).add(tenure || 1, 'y').subtract(1, 'day')
  const endDate = moment(startDate).add(tenurePa || 1, 'y').subtract(1, 'day')
  return {
    dob: moment(formData.dob).format('D-MM-YYYY'),
    fromYear: startDate.format('YYYY'),
    fromMonth: startDate.format('MMMM'),
    fromDate: startDate.format('D'),
    tenureYear: tenureEnd.format('YYYY'),
    toYear: endDate.format('YYYY'),
    toMonth: endDate.format('MMMM'),
    toDate: endDate.format('D'),
  }
}

const renderPdf = (element, policyNumber, is_merge_pdf, resolve, reject) => {
  const doc = new jsPDF('p', 'pt', 'a4', true)
  doc.addFont(PoppinsRegular, 'Poppins', 'normal')
  doc.setFont('Poppins')
  doc.html(ReactDOMServer.renderToString(element), {
    html2canvas: { scale: 0.95, useCORS: true },
    processData: false,
    contentType: false,
    margin: [0, 20, 0, 20],
    autoPaging: 'text',
    callback(doc) {
      if (is_merge_pdf) {
        const base64 = doc.output('datauristring').split(',')[1]
        resolve(base64)
      } else {
        doc.save(policyNumber.replace('/', '_') + '.pdf')
        resolve()
      }
    },
  })
}


// ─── Reusable Section Components ────────────────────────────────────────────

const BrilljustHeader = () => (
  <div className="header-container-pdf">
    <img src={logo} width={230} height={50} alt="" />
    <div className="alliance_section">
      <p className="alliance_heading">Brilljust Solutions Private Limited</p>
      <p>ALT-F, Suncity Success Tower, <br /> Sec-65 Golf Course Ext. <br /> Road,Gurgaon (hr) :122005</p>
    </div>
  </div>
)

const RSASupport = ({ crossRoad, portalId }) => {
  // portalId==2: Crossroads contact details; otherwise default Brilljust/Alliance details
  const isCrossroads = crossRoad && portalId == 2

  if (crossRoad) {
    return (
      <div className="comp-details-block Alliance_Assure_fixed">
        <p style={{ color: '#1A1B1D' }}>For Any Assistance For RSA</p>
        <p>Call or Email Us:</p>
        <div className="support_container_pdf">
          <img src={call} alt="" />
          <p>{isCrossroads ? '+91-9711640909' : '9999010010'}</p>
        </div>
        <div className="support_container_pdf">
          <img src={mail} alt="" />
          <p>{isCrossroads ? 'care@crossroadshelpline.com' : 'support@brilljust.com'}</p>
        </div>
      </div>
    )
  }

  return (
    <div className="comp-details">
      <div className="comp-details-block">
        <div className="alliance_head_details">
          <p>Alliance Assure Private Limited</p>
          <img src={allianceLogo} alt="" />
        </div>
        <p style={{ color: '#1A1B1D' }}>For Any Assistance For RSA</p>
        <p>Call or Email Us:</p>
        <div className="support_container_pdf"><img src={call} alt="" /><p>1800 212 7559</p></div>
        <div className="support_container_pdf"><img src={mail} alt="" /><p>support@allianceassure.com</p></div>
      </div>
    </div>
  )
}

const PaymentDetail = ({ formData, basicPlanAmt, basicCcAmt, planGST }) => (
  <div className="policy-container-pdf">
    <p>{formData.is_opt_gst ? 'Plan Details' : 'Payment Detail'}</p>

    <div className="payment-head-value">
      <p>{formData.is_opt_gst ? `PLAN-${formData.planBuyPrice}` : 'RSA BASE'}</p>
      {!formData.is_opt_gst && <p>₹ {basicPlanAmt}</p>}
    </div>

    {/* {formData?.cc_plan_amount && basicCcAmt && (
      <div className="payment-head-value">
        <p>
          {formData.is_opt_gst ? 'Complete Care Plan ' : 'Complete Care Plan'}
          {formData.is_opt_gst && <img src={tick} alt="" />}
        </p>
        {!formData.is_opt_gst && <p>₹ {basicCcAmt}</p>}
      </div>
    )} */}

    {!formData.is_opt_gst && (
      <>
        <div className="payment-head-value">
          <p>{formData.state === 'HARYANA' ? 'CGST (9%) + SGST (9%)' : 'IGST (18%)'}</p>
          <p>₹ {planGST}</p>
        </div>
        <div className="payment-head-value">
          <p>Total</p>
          <p>₹ {parseFloat(formData.planBuyPrice) + (formData.cc_plan_amount ? formData.cc_plan_amount : "")}</p>
        </div>
      </>
    )}
  </div>
)

const ServiceIcon = ({ src, label, flag }) => {
  if (label === "Ambulance Cover" && !flag) {
    return null;
  }

  return (
    <div className="service-square">
      <div className="service-icon-circle">
        <img src={src} alt="" width={60} height={60} />
      </div>
      <p>{label}</p>
    </div>
  );
};

const SERVICE_ROW_1 = [
  { src: onlineSupport, label: 'Online support for repairs' },
  { src: rundown, label: 'Rundown of battery' },
  { src: customer, label: 'Customer Coverage Care' },
  { src: tyre, label: 'Flat Tyre' },
  { src: fuel, label: 'Fuel Assistance' },
  { src: towAssist, label: 'Towing Assistance' },
]

const SERVICE_ROW_2 = [
  { src: emergency, label: 'Emergency Assistance' },
  { src: keyAssist, label: 'Key Assistance' },
  { src: taxiAssist, label: 'Taxi Assistance' },
  { src: accomadation, label: 'Accommodation Assistance' },
  { src: outward, label: 'Outward / Forward Journey' },
  { src: arrangement, label: 'Arrangement of Rental Vehicle' },
  { src: urgent, label: 'Urgent Message Relay' },
  { src: ambulance, label: 'Ambulance Cover' },

]

// Shared insurer table used in all three insurer sections
const InsurerTable = ({ formData, policyNumber, dates }) => {
  const { dob, fromDate, fromMonth, fromYear, toDate, toMonth, toYear } = dates
  return (
    <>
      <div className="policy-pddf-container">
        <div className="block-head-value-pol">
          <p>Master Policy Number :</p>
          <p>{formData.masterPolicyNumber}</p>
        </div>
        <div className="block-head-value-pol block-head-value-pol-bold">
          <p>Issuing Office :</p>
          <p>{formData.isManipalCheck ? 'Mumbai' : 'Gurgaon'}</p>
        </div>
        <div className="block-head-value-pol">
          <p>Beneficiary's Address :</p>
          <p>{formData.addressLineOne + ' ' + formData.addressLineTwo}</p>
        </div>
        <div className="block-head-value-pol">
          <p>Beneficiary ID No :</p>
          <p>{policyNumber}</p>
        </div>
        <div className="block-head-value-pol">
          <p>Certificate Inception date :</p>
          <p>From - {`${fromDate}-${fromMonth}-${fromYear}`} Expiry date : {`${toDate}-${toMonth}-${toYear}`}</p>
        </div>
      </div>

      <div className="pdf-table">
        <div className="table-row pdf_header">
          {['Name of the Member Covered', 'Date of Birth/Age', 'Gender', 'Nominee Name', 'Nominee Age', 'Nominee Relationship with Member', 'Benefits', 'Sum Insured']
            .map((h, i) => <div key={i} className={`table-cell table-cell-${['one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight'][i]}`}>{h}</div>)}
        </div>
        <div className="table-row">
          <div className="table-cell table-cell-one">{formData.firstName + ' ' + formData.lastName}</div>
          <div className="table-cell table-cell-two">{dob}</div>
          <div className="table-cell table-cell-three">{formData.gender}</div>
          <div className="table-cell table-cell-four">{formData.nomineeName}</div>
          <div className="table-cell table-cell-five">{formData.nomineeAge}</div>
          <div className="table-cell table-cell-six">{formData.nomineeRelation}</div>
          <div className="table-cell table-cell-seven">Accidental death</div>
          <div className="table-cell table-cell-eight">INR 1500000</div>
        </div>
      </div>
    </>
  )
}

const CommonExclusions = ({ isFutureGenerali }) => (
  <div className="content-block-pdf content-block-pdf-three">
    <p>Important Exclusions in brief: <span>
      The insurance cover herein does not cover death{isFutureGenerali ? ', injury or disablement' : ''} resulting from:
    </span></p>
    <p>
      {isFutureGenerali ? (
        <>
          • Services on duty with any armed forces. <br />
          • Intentional self injury, suicide or attempted suicide, insanity, venereal diseases or the influence of intoxicating drug. <br />
          • Medical or surgical treatment. <br />
          • Aviation other than as a passenger (fare-paying or otherwise) in any duly licensed standard type of aircraft anywhere in the world. <br />
          • Nuclear radiation or nuclear weapons related accident. <br />
          • War & warlike operation, the act of foreign enemy, civil war & similar risk. <br />
          • Child birth, pregnancy or other physical cause peculiar to the female sex. <br />
          • Whilst committing any breach of law with criminal intent.
        </>
      ) : (
        <>
          • Suicide, attempt to Suicide or intentionally self-inflicted injury, sexually transmitted conditions. <br />
          • Being under influence of drugs, alcohol, or other intoxication or hallucinogens. <br />
          • Participation in actual or attempted felony, riot, civil commotion, crime misdemeanor. <br />
          • Committing any breach of law of land with criminal intent. <br />
          • Professional sports team in respect of specific benefit for inability to perform. <br />
          • Participation in any kind of motor speed contest. <br />
          • Child birth, pregnancy or other physical cause peculiar to the female sex. <br />
          • Radioactivity, Nuclear risks, ionizing radiation.<br />
          • Animal bite/Snake Bite/Insect bite is not covered.<br />
          • Perils of the sea are excluded from the scope of the policy.
        </>
      )}
    </p>
  </div>
)


// ─── Insurer Sections ────────────────────────────────────────────────────────

const ManipalSection = ({ formData, policyNumber, dates }) => (
  <section className="pdf-container">
    <div className="header-insurer">
      <img src={manipalcignaLogo} alt="" width={140} height={80} />
      <p style={{ marginLeft: '70px' }}>
        Details of Personal Accident Cover <br />
        Master Policy Holder Name: BRILLJUST SOLUTIONS PVT LTD
      </p>
    </div>

    <InsurerTable formData={formData} policyNumber={policyNumber} dates={dates} />

    <div className="broker-details-pdf">
      <div className="broker-head-value"><p>Intermediary Name:</p><p>Arvind Agarwal</p></div>
      <div className="broker-head-value"><p>Intermediary Email:</p><p>claims.brilljust@gmail.com</p></div>
      <div className="broker-head-value"><p>Intermediary Contact No:</p><p>79059 33993</p></div>
    </div>

    <div className="content-block-pdf">
      <p>Details of GPA Policy</p>
      <p>If the Insured person sustains any bodily injury during the policy period which directly and independently
        of all other causes result in death stated below within 12 months from the date of accident resulting solely
        and directly from Accident then the Company shall pay to the insured the sum set in the schedule to the
        Insured person's nominee, beneficiary or legal representative. This certificate is effective only if the
        vehicle is registered in the name of insured person as on date of accident.</p>
    </div>

    <div className="content-block-pdf content-block-pdf-two">
      <p>Important Notes:</p>
      <p>
        1. You are covered up to age of 70 years only, any claim above age of 70 under this certificate will not be processed/ settled. <br />
        2. The personal accident coverage is applicable only to the owner of the vehicle for which Road Side Assistance service has been provided by the Brilljust Solutions Pvt. Ltd. <br />
        3. The said personal accident cover is active only whilst the owner is driving the said vehicle. <br />
        4. Death claims due to any other incidence would not be covered
      </p>
    </div>

    <div className="content-block-pdf content-block-pdf-three">
      <p>Important Notes: <span>Please refer to policy for detail information on coverage, exclusion and other terms and conditions</span></p>
      <p>• Death only. (15Lakh)</p>
    </div>

    <CommonExclusions isFutureGenerali={false} />

    <div className="distinguishTable-container">
      <div className="distinguishTable-header">
        <p>Claim Assistance</p>
        <p>Grievance Redressal</p>
      </div>
      <div className="distinguishTable-content">
        <div className="distinguishTable-content-left distinguishTable-content-block">
          <p>1. In the event of a Claim – Please contact us through any of these modes.</p>
          <p>2. Address for Correspondence – ManipalCigna Health Insurance Company Limited, 02nd Floor, Tech web Centre, New Link Road, Anand Nagar, Jogeshwari West, Mumbai -400102.</p>
          <p>Contact No – 1800-102-4461</p>
          <p>Email: <a href="mailto:healthclaims@manipalcigna.com">healthclaims@manipalcigna.com</a></p>
          <p>3. To Know the Process of Claims, visit <a href="https://www.manipalcigna.com/claims" target="_blank">www.manipalcigna.com/claims</a></p>
        </div>
        <div className="distinguishTable-content-right distinguishTable-content-block">
          <p>
            L1. Health Relationship Managers :<br />
            Call our toll-free number 1800-102-4462 between 9:00AM to 9:00PM<br />
            Email: <a href="mailto:headcustomercare@manipalcigna.com">headcustomercare@manipalcigna.com</a><br />
            For Senior Citizen Assistance - <a href="mailto:seniorcitizensupport@ManipalCigna.com">Seniorcitizensupport@ManipalCigna.com</a>
          </p>
          <p>
            L2. Grievance Redressal Officer,<br />
            Call us on 022-71781389 between 10 am to 6 Pm (Monday to Friday)<br />
            Email us at: <a href="mailto:complaints@manipalcigna.com">complaints@manipalcigna.com</a>
          </p>
          <p>
            L3. Chief Grievance Redressal Officer,<br />
            Call us on 022-71781300 between 10 am to 6 Pm (Monday to Friday)<br />
            Email us at: <a href="mailto:headcustomercare@manipalcigna.com">headcustomercare@manipalcigna.com</a><br />
            For Senior Citizen Assistance - <a href="mailto:seniorcitizensupport@ManipalCigna.com">Seniorcitizensupport@ManipalCigna.com</a><br />
            For updated Grievance Redressal Procedure, kindly refer link - <a href="https://www.manipalcigna.com/grievance-redressal" target="_blank">https://www.manipalcigna.com/grievance-redressal</a>
          </p>
        </div>
      </div>
    </div>
  </section>
)

const IciciSection = ({ formData, policyNumber, dates }) => (
  <section className="pdf-container">
    <div className="header-insurer">
      <img src={iciciLombard} alt="" width={140} height={60} />
      <p style={{ marginLeft: '70px' }}>
        Details of Personal Accident Cover <br />
        Master Policy Holder Name: BRILLJUST SOLUTIONS PVT LTD
      </p>
    </div>

    <InsurerTable formData={formData} policyNumber={policyNumber} dates={dates} />

    <div className="broker-details-pdf">
      <div className="broker-head-value"><p>Broker Name:</p><p>Good Insurance Brokers Pvt Ltd</p></div>
      <div className="broker-head-value"><p>Broker Email:</p><p>claims.ggn@good.in</p></div>
    </div>

    <div className="content-block-pdf">
      <p>Details of GPA Policy</p>
      <p>If the Insured person sustains any bodily injury during the policy period which directly and independently
        of all other causes result in death stated below within 12 months from the date of accident resulting solely
        and directly from Accident then the Company shall pay to the insured the sum set in the schedule to the
        Insured person's nominee, beneficiary or legal representative. This certificate is effective only if the
        vehicle is registered in the name of insured person as on date of accident.</p>
    </div>

    <div className="content-block-pdf content-block-pdf-two">
      <p>Important Notes:</p>
      <p>
        1. You are covered up to age of 70 years only, any claim above age of 70 under this certificate will not be processed/ settled. <br />
        2. The personal accident coverage is applicable only to the owner of the vehicle for which Road Side Assistance service has been provided by the Brilljust Solutions Pvt. Ltd. <br />
        3. The said personal accident cover is active only whilst the owner is driving the said vehicle. <br />
        4. Death claims due to any other incidence would not be covered<br />
        5. The policy is valid for 365 days from the policy risk start date
      </p>
    </div>

    <div className="content-block-pdf content-block-pdf-three">
      <p>Important Notes: <span>Please refer to policy for detail information on coverage, exclusion and other terms and conditions</span></p>
      <p>• Death only. (15Lakh)</p>
    </div>

    <CommonExclusions isFutureGenerali={false} />

    <div className="content-block-pdf content-block-pdf-three">
      <p>Claim Procedure: <span>An indicative document list in case of claim is as given below.</span></p>
    </div>

    <div className="distinguishTable-container">
      <div className="distinguishTable-header">
        <p>Claim Assistance</p>
        <p>Grievance Redressal</p>
      </div>
      <div className="distinguishTable-content">
        <div className="distinguishTable-content-left distinguishTable-content-block">
          <p>1. The Insured shall intimate the claims with all the necessary documents to our claim processing team immediately and in any event within 7 days of claim intimation.</p>
          <p>2. The Insured shall deliver to the Company, within 14 days of the date on which the event shall have come to his knowledge, a detailed statement in writing as per the claim form and any other material particular, relevant to the making of such claim.</p>
          <p>3. Customer to send documents to Company at: ICICI Lombard General Insurance Company Limited, 1st, 4th (Half), 5th and 6th floors, Varun Towers-II, Opp. Hyderabad Public School, Begumpet Hyderabad District Hyderabad, Pin code - 500016</p>
          <p>4. Download the Claim Form here: <a href="https://www.icicilombard.com/downloads" target="_blank">https://www.icicilombard.com/downloads</a></p>
        </div>
        <div className="distinguishTable-content-right distinguishTable-content-block">
          <p>
            L1. In case of any grievance the insured person may contact the Company through:<br />
            Website: <a href="http://www.icicilombard.com" target="_blank">www.icicilombard.com</a> ;- Toll free: 1800 2666<br />
            Email: <a href="mailto:customersupport@icicilombard.com">customersupport@icicilombard.com</a><br />
            Address: ICICI Lombard General Insurance Co. Ltd. Ground floor- Interface 11, Sixth floor- Interface 16, Office no 601 & 602, New Linking Road, Malad (West), Mumbai – 400064
          </p>
          <p>L2. There is an interactive voice response (IVR) facility for senior citizens' grievance redressal for easy and faster resolution.</p>
          <p>L3. Insured person may also approach the grievance cell at any of the company's branches with the details of grievance. For branch details, please visit: <a href="https://www.icicilombard.com/docs/default-source/policy-wordingsproduct-brochure/final-gro-mapping.pdf" target="_blank">https://www.icicilombard.com/docs/default-source/policy-wordingsproduct-brochure/final-gro-mapping.pdf</a></p>
          <p>L4. If insured person is not satisfied with the redressal of grievance, insured person may contact the grievance redressal officer.</p>
          <div className="download-link-footer">
            <p>You can download our Grievance Redressal Procedure.</p>
            <a href="https://www.icicilombard.com/grievanceredressal.com" target="_blank">https://www.icicilombard.com/grievanceredressal.com</a>
          </div>
        </div>
      </div>
    </div>
  </section>
)

const FutureGeneraliSection = ({ formData, policyNumber, dates }) => (
  <section className="pdf-container">
    <div className="header-insurer">
      <img src={future} alt="" width={100} height={50} />
      <p>
        Details of Personal Accident Cover <br />
        Master Policy Holder Name: BRILLJUST SOLUTIONS PVT LTD
      </p>
    </div>

    <InsurerTable formData={formData} policyNumber={policyNumber} dates={dates} />

    <div className="broker-details-pdf">
      <div className="broker-head-value"><p>Broker Name:</p><p>Viaansh Insurance Brokers Pvt. Ltd.</p></div>
      <div className="broker-head-value"><p>Broker Email:</p><p>contact@viaanshinsurance.com</p></div>
      <div className="broker-head-value"><p>Broker Contact No:</p><p>98112 23458</p></div>
    </div>

    <div className="content-block-pdf">
      <p>Details of GPA Policy</p>
      <p>If the Insured person sustains any bodily injury during the policy period which directly and independently of all other causes result in death/ disablement
        stated below within 12 months from the date of accident resulting solely and directly from Accident then the Company shall pay to the insured the sum set in
        the schedule to the Insured person's nominee, beneficiary or legal representative. This certificate is effective only if the vehicle is registered in the name of
        insured person as on date of accident.</p>
    </div>

    <div className="content-block-pdf content-block-pdf-two">
      <p>Important Notes:</p>
      <p>
        1. You are covered up to age of 70 years only, any claim above age of 70 under this certificate will not be processed/ settled. <br />
        2. The personal accident coverage is applicable only to the owner of the vehicle for which Road Side Assistance service has been provided by the Brilljust Solutions Pvt. Ltd. <br />
        3. The said personal accident cover is active only whilst the owner is driving the said vehicle including mounting into/dismounting from the said vehicle. <br />
        4. Death or permanent total disability claims due to any other incidence would not be covered <br />
        5. The policy is valid for 365 days from the policy risk start date
      </p>
    </div>

    <div className="content-block-pdf content-block-pdf-three">
      <p>Important Notes: <span>Please refer to policy for detail information on coverage, exclusion and other terms and conditions</span></p>
      <p>• Death only. (15Lakh)</p>
    </div>

    <CommonExclusions isFutureGenerali={true} />

    <div className="content-block-pdf content-block-pdf-three">
      <p>Claim Procedure: <span>An indicative document list in case of claim is as given below.</span></p>
    </div>

    <div className="distinguishTable-container">
      <div className="distinguishTable-header">
        <p>Claim Assistance</p>
        <p>Grievance Redressal</p>
      </div>
      <div className="distinguishTable-content">
        <div className="distinguishTable-content-left distinguishTable-content-block">
          <p>1. In case of any service requirement, do call our care lines below: 1800-220-233, 1860-500-3333, 022-67837800.</p>
          <p>1. The claims would be serviced through In-House Health Administrator, Future Generali Health (FGH) Team. The claim documents can be submitted directly to: Future Generali Health (FGH), Future Generali India Insurance Company Ltd, Office No. 3, 3rd Floor, Building A, G-O-Square, Aundh Hinjewadi Link Road, Wakad Pune, Maharashtra - 411 057</p>
          <p>1. It is mandatory to intimate the accidents to Future Generali through: Email ID - fgh@futuregenerali.in</p>
          <p>1. For any claim related queries please call: Toll free number - 1800 209 1016 / 1800 103 8889, Toll free Fax - 1800 209 1017 / 1800 103 9998, Email ID - fgh@futuregenerali.in</p>
        </div>
        <div className="distinguishTable-content-right distinguishTable-content-block">
          <p>L1. You can call on our helpline 1800-220-233 / 1860-500-3333 / 022-67837800 or send us an email fgcare@futuregenerali.in or visit branch grievance redressal officer (GRO) walk-in to any of our nearest branches and request to meet the GRO.</p>
          <p>L2. If the solution provided to you does not meet your expectations, you can write directly to our corporate GRO. Send us an email fggro@futuregenerali.in or call us on +91-79001 97777 or send your complaint to our corporate grievance redressal officer Mr. Hari Shankar Mishra, Future Generali India Insurance Company Ltd, Lodha I-Think Techno Campus, B Wing - 2nd Floor, Pokhran Road - 2, Off Eastern Express Highway Behind TCS, Thane West - 400607</p>
          <p>L3. If you are still not satisfied with the solution provided, you can email our CEO's office. EMAIL OUR CEO's OFFICE fgceo@futuregenerali.in</p>
          <div className="download-link-footer">
            <p>You can download our Grievance Redressal Procedure.</p>
            <a href="https://general.futuregenerali.in/footer-pdf/grievance-redressal-procedures.pdf" target="_blank">https://general.futuregenerali.in/footer-pdf/grievance-redressal-procedures.pdf</a>
          </div>
        </div>
      </div>
    </div>
  </section>
)

// Picks the right insurer section based on formData flags
const InsurerSection = ({ formData, policyNumber, dates }) => {
  if (formData.isManipalCheck) return <ManipalSection formData={formData} policyNumber={policyNumber} dates={dates} />
  if (formData.isIciciCheck) return <IciciSection formData={formData} policyNumber={policyNumber} dates={dates} />
  return <FutureGeneraliSection formData={formData} policyNumber={policyNumber} dates={dates} />
}


// ─── Page-level Sections ─────────────────────────────────────────────────────

// Page 1: RSA Certificate
const PageOne = ({ formData, policyNumber }) => {
  const dates = calcDates(formData)
  const amounts = calcAmounts(formData)
  const { fromYear, fromMonth, fromDate, tenureYear, toMonth, toDate } = dates

  return (
    <section className="pdf-container">
      {!formData.is_opt_gst && (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '8px', marginBottom: '4px' }}>
          Tax Invoice Cum Certificate
        </div>
      )}

      <BrilljustHeader />

      <div className="pdfContent" style={{ gap: formData.portalId == 2 ? "2rem" : "none" }}>
        <div className="pdfContent-header">
          <div>
            <p className="headTitle">Product: <span>{formData.productName}</span></p>
            <p className="headTitle-gray">Master Policy Number: {formData.masterPolicyNumber}</p>
          </div>
          <div className="policyHolderDetailsBlock policyHolderDetailsBlock_blue">
            <div className="policyHolderDetail-container">
              <div className="titleDescription-policy titleDescription-policy_copy">
                <p>Certificate Number</p>
                <p>{policyNumber}</p>
              </div>
              <div className="titleDescription-policy" />
            </div>
          </div>
        </div>

        <div className="flex-container-pdf" style={{ gap: formData.portalId == 2 ? "2rem" : "none" }}>
          {/* Left column */}
          <div className="flex-container-pdf-left">
            <div className="policyHolderDetails">
              <div className="policyHolderDetailsBlock">
                <div className="policyHolderDetail-container">
                  <div className="titleDescription-policy">
                    <p>Insured Name</p><p>{formData.firstName + ' ' + formData.lastName}</p>
                  </div>
                  <div className="titleDescription-policy">
                    <p>Mobile Number</p><p>{formData.mobileNumber}</p>
                  </div>
                </div>
                <div className="policyHolderDetail-container">
                  <div className="titleDescription-policy">
                    <p>Email ID</p><p>{formData.emailId}</p>
                  </div>
                  <div className="titleDescription-policy">
                    {formData.gstNumber && <><p>GST Number</p><p>{formData.gstNumber}</p></>}
                  </div>
                </div>
                <div className="policyHolderDetail-container">
                  <div className="titleDescription-policy">
                    <p>Address</p><p>{formData.addressLineOne + ' ' + formData.addressLineTwo}</p>
                  </div>
                  <div className="titleDescription-policy" />
                </div>
              </div>
            </div>

            <div className="vehicle-details-block" style={{ gap: formData.portalId == 2 ? "1.5rem" : "none" }}>
              <div className="vehicle-details-header"><img src={tow} alt="" /><p>Vehicle Details</p></div>
              <div className="title-desc-vehicle"><p>Registration Number</p><p>{formData.businessType?.toLowerCase() === 'new' ? 'NEW' : formData.vehicleNumber}</p></div>
              <div className="title-desc-vehicle"><p>Vehicle Type</p><p>{formData.vehicleType || 'Two Wheeler'}</p></div>
              <div className="title-desc-vehicle"><p>Make</p><p>{formData.make}</p></div>
              <div className="title-desc-vehicle"><p>Model / Variant</p><p>{formData.model}</p></div>
              <div className="title-desc-vehicle"><p>Engine Number</p><p>{formData.engineNumber}</p></div>
              <div className="title-desc-vehicle"><p>Chassis Number</p><p>{formData.chassisNumber}</p></div>
            </div>
          </div>

          {/* Right column */}
          <div className="flex-container-pdf-right" style={{ gap: formData.portalId == 2 ? "2rem" : "none" }}>
            <div className="policyDetails">
              <div className="calendar_container_pdf">
                <div className="calendar">
                  <div className="calendar-year"><p>{fromYear}</p></div>
                  <div className="calendar-details">
                    <p>Certificate Start Date</p><p>{fromDate}</p><p>{fromMonth}</p>
                  </div>
                </div>
                <div className="calendar">
                  <div className="calendar-year"><p>{tenureYear}</p></div>
                  <div className="calendar-details">
                    <p>Certificate End Date</p><p>{toDate}</p><p>{toMonth}</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="comp-details-container" style={{ gap: formData.portalId == 2 ? "2rem" : "none" }}>
              <RSASupport crossRoad={formData.crossRoad} portalId={formData.portalId} />
              <PaymentDetail formData={formData} {...amounts} />
            </div>
          </div>
        </div>

        {/* Services */}
        {formData.portalId != 2 &&
          <div className="service-container">
            <p>The Services Provided Under The Assistance Are As Follows:</p>

            {/* Row 1: first icon + 6 service icons */}
            <div className="service-container-block">
              <div className="service-square">
                {formData.cc_plan_amount ? (
                  <div className="service-icon-circle_highlighted">
                    <img src={highligtedCircle} alt="" width={60} height={60} />
                  </div>
                ) : (
                  <div className="service-square">
                    <div className="service-icon-circle"><img src={coverage} alt="" width={60} height={60} /></div>
                    <p>100% Claim Service</p>
                  </div>
                )}
                {/* {formData.cc_plan_amount && <p style={{ color: '#000096' }}>Complete Care</p>} */}
              </div>
              {SERVICE_ROW_1.map((item) => <ServiceIcon key={item.label} {...item} />)}
            </div>

            {/* Row 2: remaining 7 service icons */}
            <div className="service-container-block">
              {SERVICE_ROW_2.map((item) => <ServiceIcon key={item.label} {...item} flag={formData.ambulanceCover} />)}
            </div>

            <p>Customers are responsible for all expenses, including consumables, accommodation, taxis, rentals, tolls, and border charges.</p>
          </div>
        }

      </div>
    </section>
  )
}

// Page 2 (portalId==2): Crossroads-specific Terms & Conditions
const CrossroadsTermsPage = ({ formData }) => {
  const dates = calcDates(formData)
  const startStr = `${dates.fromDate} ${dates.fromMonth} ${dates.fromYear}`
  const endStr = `${dates.toDate} ${dates.toMonth} ${dates.tenureYear}`
  const vType = formData?.vehicleType || 'Two Wheeler'

  return (
    <section className="pdf-container">
      <br /><br />
      <BrilljustHeader />
      {/* T&C Title */}

      <div className="terms_condition_title"><p>Customer Responsibility & Terms and Conditions</p></div>





      <div className="term_content">
        <p>
          1.&nbsp;<strong>Serviceability:</strong> RSA services would be provided by Crossroads  (Roadside Awareness Pvt Ltd.)<br />
          2.&nbsp;<strong>Eligibility:</strong> Service is applicable only to vehicles registered under the plan.<br />
          3.&nbsp;<strong>Membership Validity:</strong> The RSA membership is valid for the duration as mentioned in the plan.<br />
          4.&nbsp;<strong>Service Limitations:</strong><br />
          &nbsp;&nbsp;&nbsp;&nbsp;• Towing is covered up to 25 KM; beyond that, extra charges of ₹50/KM will apply.<br />
          &nbsp;&nbsp;&nbsp;&nbsp;• Services are limited to the number of incidents as per the plan selected.<br />
          &nbsp;&nbsp;&nbsp;&nbsp;• Hydra crane, accidental recovery, or winching services are chargeable as per actuals.<br />
          5.&nbsp;<strong>Turnaround Time (TAT) for providing services:</strong><br />
          &nbsp;&nbsp;&nbsp;&nbsp;• 30–45 minutes: Within city municipal limits<br />
          &nbsp;&nbsp;&nbsp;&nbsp;• 60–90 minutes: Outside city municipal limits or Highway<br />
          &nbsp;&nbsp;&nbsp;&nbsp;• 90–120 minutes: Hilly Areas<br /><br />
          &nbsp;&nbsp;&nbsp;&nbsp;Our services are Pan India with the exception of J&amp;K, Leh Ladakh, Andaman &amp; Nicobar Island, extreme hilly &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;areas, peace disturbed areas &amp; remote locations.
        </p>
      </div>

      {/* Additional Terms */}
      {/* <div className="terms_for_Cab"><p>Additional Terms</p></div> */}

      <div className="terms_for_Cab" style={{ fontSize: '11px' }}><p>Cab Facility:</p></div>
      <div className="term_content">
        <p>
          &nbsp;&nbsp;&nbsp;&nbsp;• Up to ₹300 (Three Hundred only) within city limits.<br />
          &nbsp;&nbsp;&nbsp;&nbsp;• Up to ₹600 (Six Hundred only) on highways.<br />
        </p>
      </div>

      <div className="terms_for_Cab" style={{ fontSize: '11px' }}><p>Hotel Accommodation:</p></div>
      <div className="term_content">
        <p>
          &nbsp;&nbsp;&nbsp;&nbsp;• Stay in a 2/3-star property (depending on location) up to ₹3,500 (Three Thousand Five Hundred only) for a  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;single day.<br />
          &nbsp;&nbsp;&nbsp;&nbsp;• Cab and hotel accommodation facility can be availed once in a year per membership.
        </p>
      </div>

      {/* Exclusions */}
      <div className="terms_for_Cab" style={{ fontSize: '11px' }}><p>Exclusions:</p></div>
      <div className="term_content">
        <p>&nbsp;&nbsp;&nbsp;&nbsp;• Cost of parts, consumables, and charges are not included.</p>
      </div>

      {/* User Responsibility */}
      <div className="terms_for_Cab" style={{ fontSize: '11px' }}><p>User Responsibility:</p></div>
      <div className="term_content">
        <p>
          &nbsp;&nbsp;&nbsp;&nbsp;• Accurate vehicle and location details must be shared to avoid delays.<br />
          &nbsp;&nbsp;&nbsp;&nbsp;• The customer should ensure safe parking of the vehicle while awaiting assistance.
        </p>
      </div>

      {/* Cancellation */}
      <div className="terms_for_Cab" style={{ fontSize: '11px' }}><p>Cancellation / Refund:</p></div>
      <div className="term_content">
        <p>&nbsp;&nbsp;&nbsp;&nbsp;• No refunds are applicable once service is initiated or membership is activated.</p>
      </div>

      {/* Force Majeure */}
      <div className="terms_for_Cab" style={{ fontSize: '11px' }}><p>Force Majeure:</p></div>
      <div className="term_content">
        <p>&nbsp;&nbsp;&nbsp;&nbsp;• Services may be delayed due to natural calamities, strikes, or circumstances beyond our control.</p>
      </div>


    </section>
  )
}

// Page 2: Terms & Conditions (only shown when crossRoad is true)
const CrossRoadTermsPage = ({ formData }) => (
  <section className="pdf-container">
    <br /><br />
    <BrilljustHeader />

    <div className="terms_condition_title"><p>Customer Responsibility & Terms and Conditions</p></div>
    <div className="term_content">
      <p>Customers shall be responsible for all additional expenses, including but not limited to consumables, accommodation, taxis, rentals, tolls, and border charges.</p>
    </div>

    <div className="terms_for_Cab"><p>Roadside Assistance Terms & Conditions</p></div>
    <div className="term_content">
      <p>
        1.&nbsp;Towing services beyond 40 km will be charged on an actual basis.<br />
        2.&nbsp;Puncture repair charges for two or more flat tires will be borne by the customer on an actual basis.<br />
        3.&nbsp;Any consumables required during service will be charged additionally.
      </p>
      <div>
        <div className="TurnaroundTime"><p>4.&nbsp;Turnaround Time (TAT) for Service Provision:</p></div>
        <div className="broker-head-value">&nbsp;&nbsp;&nbsp;&nbsp;a)<p>45-60 minutes:</p><p>Within city municipal limits</p></div>
        <div className="broker-head-value">&nbsp;&nbsp;&nbsp;&nbsp;b)<p>60-90 minutes:</p><p>Outside city municipal limits or Highway</p></div>
        <div className="broker-head-value">&nbsp;&nbsp;&nbsp;&nbsp;b)<p>90-120 minutes:</p><p>Hilly Areas.</p></div>
      </div>
    </div>

    <div className="note-text_terms">
      <p>Note:&nbsp; 1. Any toll or Border Charges will be borne by the customer.<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2. Services are available Pan India, except in Leh Ladakh, Andaman & Nicobar Islands, extreme hilly areas, peace-disturbed regions, and remote locations.
      </p>
    </div>

    <div className="terms_for_Cab"><p>Cab Facility (Available Once a Year)</p></div>
    <div className="term_content">
      <p>
        1.&nbsp;Cab facility up to maximum limit of ₹300 (Three Hundred only) in city limit.<br />
        2.&nbsp;Cab facility up to maximum limit of ₹600 (Six hundred only) on highways<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Any additional fare beyond the stated limits shall be borne by the customer.
      </p>
    </div>

    <div className="terms_for_Cab"><p>Hotel Accommodation Facility (Available Once a Year)</p></div>
    <div className="term_content">
      <p>
        1.&nbsp;Accommodation is provided in a <span className="stong_text">2-star or 3-star property</span> (depending on the city)<br />
        &nbsp;up to a maximum limit of ₹3,500 (Thirty-Five Hundred only) for a single day.<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Any additional cost beyond the specified limit shall be borne by the customer.
      </p>
    </div>
    {formData?.ambulanceCover &&
      <>
        <div className="terms_for_Cab">
          <p>Ambulance Cover (Up to Rs. 2,000)</p>
        </div>

        <div className="term_content">
          <p>
            1.&nbsp;In the event of an accident involving the Owner-Driver,
            reasonable expenses incurred for ambulance transportation shall be
            covered up to a maximum limit of <span className="stong_text">₹2,000</span>
            (Two Thousand only), subject to the terms and conditions of the policy.
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Any expenses exceeding the specified
            limit shall be borne by the customer.
          </p>
        </div>
      </>
    }

  </section>
)


// ─── Public Export Functions ─────────────────────────────────────────────────

/**
 * Full PDF: Page 1 (RSA cert) + optional CrossRoad terms + optional insurer section
 */
export const exportPDF = (formData, policyNumber, is_merge_pdf = false) =>

  new Promise(async (resolve, reject) => {
    try {
      const dates = calcDates(formData)
      const showInsurer = !formData.is_hide_master_policy
      console.log(formData.portalId == "2", 'formData.portalId')

      const element = (
        <>
          <PageOne formData={formData} policyNumber={policyNumber} />
          {formData.crossRoad && (formData.portalId == 2 ? <CrossroadsTermsPage formData={formData} /> : <CrossRoadTermsPage formData={formData} />)}
          {showInsurer && (
            <>
              <br /><br />
              <InsurerSection formData={formData} policyNumber={policyNumber} dates={dates} />
            </>
          )}
        </>
      )
      renderPdf(element, policyNumber, is_merge_pdf, resolve, reject)
    } catch (error) {
      console.log(error)
      reject(error)
    }
  })

/**
 * Page-one-only PDF: RSA cert + optional CrossRoad terms (no insurer section)
 */
export const exportPdfPageOne = (formData, policyNumber, is_merge_pdf = false) =>
  new Promise(async (resolve, reject) => {
    try {
      const element = (
        <>
          <PageOne formData={formData} policyNumber={policyNumber} />
          {formData.crossRoad && (formData.portalId == 2 ? <CrossroadsTermsPage formData={formData} /> : <CrossRoadTermsPage formData={formData} />)}
        </>
      )
      renderPdf(element, policyNumber, is_merge_pdf, resolve, reject)
    } catch (error) {
      console.log(error)
      reject(error)
    }
  })

/**
 * Page-two-only PDF: insurer section only
 */
export const exportPdfPageTwo = (formData, policyNumber, is_merge_pdf = false) =>
  new Promise(async (resolve, reject) => {
    try {
      const dates = calcDates(formData)
      const element = (
        <InsurerSection formData={formData} policyNumber={policyNumber} dates={dates} />
      )
      renderPdf(element, policyNumber, is_merge_pdf, resolve, reject)
    } catch (error) {
      console.log(error)
      reject(error)
    }
  })


// ─── Utility Exports ─────────────────────────────────────────────────────────

export const getBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => resolve(reader.result.split(',')[1])
    reader.onerror = (error) => reject(error)
  })

export const base64ToUint8Array = (base64String) => {
  const binaryString = window.atob(base64String)
  const bytes = new Uint8Array(binaryString.length)
  for (let i = 0; i < binaryString.length; i++) {
    bytes[i] = binaryString.charCodeAt(i)
  }
  return bytes
}